import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
/* eslint-disable */
import RecommendationsProduct from '../Recommendations/RecommendationsProduct';
import ImageCarousel from '../ImageCarousel/ImageCarousel';
import { CombinedImage } from '@ynap/image';
import { upsellListImpression } from '../analytics/';

const bem = new BEMHelper('Outfits');

const pagination = (outfitIndex, numberOfsets) => {
    const goNextDisable = outfitIndex >= numberOfsets ? 'disable' : '';
    const goPrevDisable = outfitIndex <= 1 ? 'disable' : '';
    return ({ goPrev = () => {}, goNext = () => {} }) => {
        return (
            <div className={bem('paginationWrapper')}>
                <span
                    className={bem('prev', goPrevDisable)}
                    onClick={() => {
                        goPrev();
                    }}
                ></span>
                <span className={bem('pagination')}>
                    {outfitIndex} / {numberOfsets}
                </span>
                <span
                    className={bem('next', goNextDisable)}
                    onClick={() => {
                        goNext();
                    }}
                ></span>
            </div>
        );
    };
};

const Outfits = (props) => {
    const { recommendations, messages, heading, tracking = {}, type, onClick = () => {} } = props;

    //array of images for each outfit view set
    if (!Array.isArray(recommendations)) return null;

    const outfitViewImages = recommendations.map((r, index) => {
        return {
            id: index,
            ...r.outfitImage,
        };
    });

    const numberOfsets = recommendations.length;
    const [outfitIndex, setOutfitIndex] = useState(0);
    const outfitView = recommendations[outfitIndex];
    const recommendationsVisible = outfitView?.products && outfitView.products.length > 0;

    useEffect(() => {
        if (recommendationsVisible) {
            tracking?.trackEvent(upsellListImpression(recommendations?.[0]?.products, type));
        }
    }, [type, recommendationsVisible]);

    const updateIndex = (newIndex) => {
        //move right
        if (newIndex > outfitIndex) {
            if (newIndex < numberOfsets) {
                setOutfitIndex(newIndex);
            } else {
                setOutfitIndex(0);
            }
        }

        //move left
        else {
            if (newIndex >= 0) {
                setOutfitIndex(newIndex);
            } else {
                setOutfitIndex(numberOfsets - 1);
            }
        }
    };

    const prevOutfit = () => updateIndex(outfitIndex - 1);
    const nextOutfit = () => updateIndex(outfitIndex + 1);

    const Pagination = numberOfsets > 1 ? pagination(outfitIndex + 1, numberOfsets) : '';

    return (
        <div className={bem('container')}>
            <div className={bem('topDivider')} />
            <div className={bem('headerWrapper')}>
                <h3 className={bem('header')}>{heading()}</h3>
            </div>
            {recommendationsVisible && (
                <Fragment>
                    <div className={bem('outfitCarousel')}>
                        <div className={bem('outfitCarouselContent')}>
                            {outfitViewImages.length === 1 ? (
                                <CombinedImage
                                    src={outfitViewImages[0].url}
                                    alt={outfitViewImages[0].alt}
                                    primarySrcset={outfitViewImages[0].srcSet}
                                    displaySrc={true}
                                    yOffset={'100%'}
                                    className={bem('combinedImage')}
                                    cover={'cover'}
                                />
                            ) : (
                                <ImageCarousel
                                    images={outfitViewImages}
                                    imageSrcsetSize="(min-width: 1024px) 560px, (min-width: 768px) 40vw, 75vw"
                                    computeAttributes={false}
                                    goNext={nextOutfit}
                                    goPrev={prevOutfit}
                                    Pagination={Pagination}
                                    hideMobileArrow={true}
                                    padding={'noPadding'}
                                    showHint={true}
                                />
                            )}
                        </div>
                    </div>
                    <div className={bem('productWrapper')}>
                        {outfitView.products.map((recommendedProduct, index) => {
                            return (
                                <RecommendationsProduct
                                    recommendedProduct={recommendedProduct}
                                    index={index}
                                    messages={messages}
                                    onClick={onClick}
                                    key={recommendedProduct && recommendedProduct.href}
                                    type="landscape"
                                />
                            );
                        })}
                    </div>
                </Fragment>
            )}
        </div>
    );
};

Outfits.propTypes = {
    recommendations: PropTypes.array,
    messages: PropTypes.object,
    onClick: PropTypes.func,
    heading: PropTypes.string,
    tracking: PropTypes.object,
    type: PropTypes.string,
};

export default Outfits;
